import { signOut } from 'next-auth/react';
import { useEffect } from 'react';
import { Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { AssessmentButtons } from './assessment-buttons';
import { AssessmentHeader } from './assessment-header';
import { AssessmentCard } from './assessment-card';
import { selectMatching } from '../../../redux/matching';
import { selectReferralSource } from '../../../redux/session';
import { ReferralSource } from '../../../redux/types';
import ZocdocCancellationAlert from '../matching/zocdoc-cancellation-alert';
import WhatWeCantTreatDialog from '../what-we-cant-treat-dialog';

interface PropTypes {
  title: string;
  body: string;
  buttonText?: string;
  url?: string;
  shouldShowWhatWeCantTreatDialog?: boolean;
}

export const HardTermination = ({
  title,
  body,
  buttonText,
  url,
  shouldShowWhatWeCantTreatDialog,
}: PropTypes) => {
  const { zocdocProvider } = useSelector(selectMatching);
  const referralSource = useSelector(selectReferralSource);
  const isZocdocReferral = referralSource === ReferralSource.Zocdoc;

  useEffect(() => {
    void signOut({ redirect: false });
  }, []);

  return (
    <>
      <AssessmentHeader title={title} />
      <AssessmentCard>
        <Typography>{body}</Typography>
      </AssessmentCard>
      {isZocdocReferral && zocdocProvider && <ZocdocCancellationAlert />}
      {shouldShowWhatWeCantTreatDialog && <WhatWeCantTreatDialog />}
      <AssessmentButtons
        primary={{
          endIcon: null,
          children: buttonText || 'Return home',
          href: url || 'https://www.talkiatry.com/',
        }}
      />
    </>
  );
};
